export default {
  title: 'Register a new spot',
  form: {
    name: 'Name of the spot',
    organization: 'Spot group',
    join: 'Join the group',
    submit: 'Start the free trial',
  },
  helper: {
    start: 'You are starting your free 30 days trial period (no credit card required).',
    pricing: 'Find our pricing and plans on www.verticaltopo.com',
    no_found: {
      title: 'Sorry, spot not found!',
      body: 'We couldn’t find the spot you’re looking for. Perhaps it has been deleted or you’ve mistyped the URL? Be sure to check your spelling.',
    },
    no_organization: 'Create an independent spot',
  },
}
